import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { ProjectMemberPropertiesWrapper } from '../../../pages/project/shared/project-detail-types';
import {
  BudgetOptions,
  ExpenditureOptions,
} from '../../constants-repository/project-calculation.constants';
import { UserOperation } from '../../enums/user-operation';
import { ClientModel } from '../client/client.model';
import { ProjectBudgetEntryModel } from './project-budget-entry.model';
import { ProjectExpenditureEntryModel } from './project-expenditure-entry.model';
import { ProjectTaskModel } from './project-task.model';
import { StatusModel } from './status.model';

export class ProjectModel {
  public id = null;
  public name = '';

  @Expose({ name: 'client_id', toPlainOnly: true })
  @Type(() => ClientModel)
  @Transform(({ value }) => value?.id ?? null, { toPlainOnly: true })
  public client: ClientModel | null = null;

  public color = '';

  @Expose({ name: 'status_id', toPlainOnly: true })
  @Transform(({ value }) => value.id, { toPlainOnly: true })
  @Type(() => StatusModel)
  public status: StatusModel | null = null;

  @Expose({ name: 'is_archived' })
  public isArchived = false;

  @Expose({ name: 'starts_at' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public startsAt: Date | null = null;

  @Expose({ name: 'ends_at' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public endsAt: Date | null = null;

  public remark = '';

  @Expose({ name: 'expenditureentry_set' })
  @Type(() => ProjectExpenditureEntryModel)
  public projectExpenditureEntries: readonly ProjectExpenditureEntryModel[] = [];

  @Expose({ name: 'budgetentry_set' })
  @Type(() => ProjectBudgetEntryModel)
  public projectBudgetEntries: readonly ProjectBudgetEntryModel[] = [];

  @Expose({ name: 'expenditure_type' })
  public expenditureType: ExpenditureOptions = ExpenditureOptions.ExpendituresInHours;

  @Expose({ name: 'budget_type' })
  public budgetType: BudgetOptions = BudgetOptions.NoBudget;

  @Expose({ name: 'tasks' })
  @Type(() => ProjectTaskModel)
  public tasks: readonly ProjectTaskModel[] = [];

  @Expose({ name: 'member_properties' })
  public projectMemberPropertiesWrapper: readonly ProjectMemberPropertiesWrapper[] = [];

  @Exclude()
  public userOperation = UserOperation.None;
}
